import custom from './custom.vue';
export default {
  components: {
    custom
  },
  props: {
    id: {
      type: Number,
      default: 0
    },
    menu: {
      type: String,
      default: 'home.dashboardDataBoard'
    },
    bulletinBoardList: {
      type: Object,
      default() {
        return {};
      }
    },
    delList: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      type: 'POLICY_PREMIUM',
      queryMethod: 'WHOLE',
      timeFrame: 'MONTH',
      customShow: true,
      timer1: ''
      // bulletinBoardList:{}
    };
  },
  methods: {
    delArrFun(val) {
      this.$emit('delArr', val);
    },
    tabFun(val, type) {
      this.type = val;
      this.timer1 = new Date().getTime();
      if (type) {
        this.customShow = false;
        setTimeout(() => {
          this.customShow = true;
        }, 400);
      }
    },
    callback(key, type) {
      this.$emit('setObj', this.type, {
        panelList: this.$refs.customRef.panelList,
        timeFrame: this.timeFrame,
        queryMethod: this.queryMethod,
        previewList: this.$refs.customRef.previewList,
        type: this.type
      });
      this.tabFun(key, type);
    },
    handleOk() {
      if (this.type == 'POLICY_PREMIUM') {
        this.type = 'CLAIMS';
        this.tabFun(this.type);
      } else if (this.type == 'CLAIMS') {
        this.type = 'ACHIEVEMENT';
        this.tabFun(this.type);
      } else if (this.id != 0 && this.type == 'ACHIEVEMENT') {
        this.$emit('ok');
      }
    },
    setInfoFun(val) {
      this.queryMethod = val.queryMethod;
      this.timeFrame = val.timeFrame;
    }
  }
};